export default {
      id: "search-blue-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#search-blue",
      toString: function () {
        return this.url;
      }
    }